import * as React from 'react';

import _find from 'lodash/find';

import useGetAuthorizedForms from '../api/hooks/common/useGetAuthorizedForms';
import useGetAppUserInfo from '../api/hooks/common/useGetAppUserInfo';

import { AppUser, AuthorizedForm, ReportType } from '../api/clients';

type IAppData = {
  authorizedForms: AuthorizedForm[] | undefined,
  getFormByName: (reportType: ReportType) => AuthorizedForm | undefined,
  appUserInfo: AppUser | undefined,
};

const AppData = React.createContext<IAppData>(undefined!);

export function AppDataProvider({ children }: { children: React.ReactNode }) {
  const { data: authorizedForms } = useGetAuthorizedForms();
  const { data: appUserInfo } = useGetAppUserInfo();

  const appData = React.useMemo<IAppData>(() => ({
    authorizedForms,
    appUserInfo,
    getFormByName: (reportType: ReportType) => _find(
      authorizedForms,
      (a: AuthorizedForm) => a.metadata?.reportType === reportType,
    ),
  }), [authorizedForms, appUserInfo]);

  return (
    <AppData.Provider value={appData}>
      {children}
    </AppData.Provider>
  );
}

export const useAppData = () => React.useContext(AppData);
